/*!

=========================================================
* Argon Dashboard React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from 'react';
import ReactDOM from 'react-dom';
import {
  MemoryRouter,
  BrowserRouter,
  Route,
  Switch,
  Redirect,
} from 'react-router-dom';

import './assets/plugins/nucleo/css/nucleo.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './assets/scss/argon-dashboard-react.scss';
// Custom CSS
import './assets/css/custom.css';

import AdminLayout from './layouts/Admin.js';
import SubscribeLayout from './layouts/Subscribe.js';

import utils from './utils.js';

(async function () {
  if (window.location.href.includes('?newlicense')) {
    // Clear this cookie so if users change license type, they can see the message to join
    // the appropriate Discord server (Lite or Pro)
    utils.setCookie(utils.SHOW_JOIN_DISCORD_COOKIE_NAME, undefined);
    await utils.sleep(3000);
  }
  const { user, license, errorMessage } = await utils.getUser();
  if (!user) {
    window.location.href = utils.isDevMode()
      ? 'http://localhost:4200/auth/discord'
      : `${await utils.getEndpoint()}/auth/discord`;
    return;
  }

  ReactDOM.render(
    <BrowserRouter basename="/dashboard">
      {/*<div>Dashboard is down for upgrades. -etcher</div>*/}
      <Switch>
        <Route
          path="/subscribe"
          render={(props) => (
            <SubscribeLayout {...props} user={user} license={license} />
          )}
        />
        <Route
          path="/"
          render={(props) => (
            <AdminLayout {...props} user={user} license={license} />
          )}
        />
      </Switch>
    </BrowserRouter>,
    document.getElementById('root')
  );
})();
